import React from 'react';

export interface UnplayableSourceOverlayProps {
  visible: boolean;
  message: string;
  onSwitchToProxy: () => void;
}

/**
 * Simple overlay shown when the user switches to a source that can't be played
 * in the browser (e.g. ProRes original) but a proxy is available to switch to.
 * No polling, no download link — just a message and a button.
 */
export const UnplayableSourceOverlay = React.memo(function UnplayableSourceOverlay({
  visible,
  message,
  onSwitchToProxy,
}: UnplayableSourceOverlayProps) {
  if (!visible) return null;

  return (
    <div
      className="kollab-player-download-overlay kollab-player-download-overlay--visible"
      role="alert"
      aria-label="Playback error"
    >
      <div className="kollab-player-unplayable-source">
        <h2 className="kollab-player-unplayable-source-title">Unplayable file</h2>
        <p className="kollab-player-unplayable-source-message">{message}</p>
        <button
          className="kollab-player-switch-proxy-btn"
          onClick={onSwitchToProxy}
          type="button"
        >
          Switch to Proxy
        </button>
      </div>
    </div>
  );
});
